import { render, staticRenderFns } from "./addAddressModal.vue?vue&type=template&id=427bedc8&scoped=true&"
import script from "./addAddressModal.vue?vue&type=script&lang=js&"
export * from "./addAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./addAddressModal.vue?vue&type=style&index=0&id=427bedc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427bedc8",
  null
  
)

export default component.exports